import React from 'react'
import Spinner from '../atoms/spinner/spinner'
import {history} from "../../configureHistory";
import {t} from "../../i18n";
import {orderStatuses} from "../constants/orderStatuses";
export default class Waiting extends React.Component<any, any> {
    mainIntId = 0;
    longIntId = 0;

    componentDidUpdate(): void {
        this.redirect();
    }

    componentDidMount(): void {
        this.redirect();
        if(sessionStorage && !this.props.location.state) {
          const reqID = sessionStorage.getItem('reqID');
          if (reqID)
            history.push({ pathname: `/${reqID}` })
          return;
        }
        //Preview
        let isInPreview = this.props.location.state.preview;
        if(isInPreview)
            return;

        // @ts-ignore
        let mainIntInterval = window.app.env.API_CALL_INTERVAL;
        // @ts-ignore
        let longIntInterval = window.app.env.RECHECK_WINDOW_INTERVAL;

      this.mainIntId = setInterval(() => { this.refreshOrder(); }, mainIntInterval);
      this.longIntId = setInterval(() => { this.redirectToManualCheck(); }, longIntInterval);
    }

    refreshOrder() {
      if (this.props.location.state && this.props.location.state.order)
        this.props.callGetOrder(this.props.location.state.order.LinkCode);
    }

    componentWillUnmount(): void {
        clearInterval(this.mainIntId);
        clearInterval(this.longIntId);
    }

    redirectToManualCheck = () => {
      history.push({
        pathname: "/recheck",
        state: {order: this.props.order, alreadyOpened: false}
      });
    };

    redirect = () => {
      const status = +this.props.order.OrderStatus;

      if (status === 302 || status === 301) {
        history.push({
          pathname:"/accepted",
          state:{data:this.props.order}
        });
      } else if (status === 400) {
        history.push({
          pathname: "/summary",
          state: {data: this.props.order, OrderStatus: orderStatuses.Delivered}
        });
      } else if (status === 600 || status === 500) {
        history.push({
          pathname:"/summary",
          state:{data:this.props.order, OrderStatus:orderStatuses.Canceled}
        });
      } else if (status === orderStatuses.Removed) {
        history.push({
          pathname:"/summary",
          state:{data:this.props.order, OrderStatus:orderStatuses.Removed}
        });
      }
    };

    imageStyles = {
        height: '150px',
        maxHeight: '150px',
        width: 'auto'
    };

    showImage = ()=>{
        let style = this.props.cssStyles.WaitingQueue;
        if(style.Show && style.UseCustom){
            return <img style={this.imageStyles} src={String(style.Image)} />;}
        else if(style.Show && !style.UseCustom){
            return <Spinner show={true}/>
        }
    };

    showPlaceInQueue() {
        if (this.props.cssStyles.WaitingQueue.Enabled)
            return (
              <h3>
                {t("WaitingQueue_PlaceInTheQueue")} {this.props.order.QueueNumber > 0 ? this.props.order.QueueNumber : "?"}
              </h3>
            );
    }

    showSuccessChanged = () =>{
      if (this.props.history.location.state &&
        this.props.history.location.state.successChanged) {
          switch (this.props.history.location.state.type) {
              case 1:{
                  return <p style={{color:"green"}}>{t("EnterCarPlateNumber_InputFieldTemplate")}</p>
              }
              case 2:{
                  return <p style={{color:"green"}}>{t("WaitingForArrival_InputFieldTemplate")}</p>
              }
          }
      }
    };

  render() {
    const styleCommon = {
      fontFamily: this.props.cssStyles.CommonSettings.FontFamily,
      color: this.props.cssStyles.CommonSettings.FontColor
    };

    return (
      <div>
        <div className="container text-center">
          <div className="row">
            <div className="col-12" style={styleCommon}>
              {this.showPlaceInQueue()}
              <p>{t("CommonText_FirstLine")}</p>
              <h3>{t("CommonText_SecondLine")}</h3>
              {this.showSuccessChanged()}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h2 style={styleCommon}>{t("WaitingQueue_TextUnderCommonText")}</h2>
            </div>
          </div>
          <div>
            <div className="col-12">
              {this.showImage()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
